
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2025-11-15-tsl-start",
      function () {
        return require("private-next-pages/blogs/2025-11-15-tsl-start/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2025-11-15-tsl-start"])
      });
    }
  